<div class="dashboard-page">
    <!-- Header Section -->
    <div class="page-header">
        <div class="header-content">
            <div class="title-section">
                <div class="title-icon">
                    <mat-icon>dashboard</mat-icon>
                </div>
                <div class="title-text">
                    <h1>Dashboard</h1>
                    <p class="subtitle">Welcome back! Here's your fleet overview</p>
                </div>
            </div>
            <div class="header-date">
                <mat-icon>calendar_today</mat-icon>
                <span>{{ today | date:'EEEE, MMMM d, yyyy' }}</span>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="dashboard-content">
        <!-- Stats Cards Row -->
        <div class="stats-row">
            <!-- On-Time Service Compliance -->
            <div class="stat-card compliance">
                <div class="card-header">
                    <div class="card-icon">
                        <mat-icon>schedule</mat-icon>
                    </div>
                    <span class="card-title">On-Time Service Compliance</span>
                </div>
                <div class="stat-values">
                    <div class="stat-item">
                        <div class="stat-value primary">60%</div>
                        <div class="stat-label">All-Time</div>
                        <div class="stat-bar">
                            <div class="bar-fill" style="width: 60%;"></div>
                        </div>
                    </div>
                    <div class="stat-divider"></div>
                    <div class="stat-item">
                        <div class="stat-value success">72%</div>
                        <div class="stat-label">Last 30 Days</div>
                        <div class="stat-bar success">
                            <div class="bar-fill" style="width: 72%;"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Service Reminder -->
            <div class="stat-card reminder">
                <div class="card-header">
                    <div class="card-icon warning">
                        <mat-icon>notification_important</mat-icon>
                    </div>
                    <span class="card-title">Service Reminder</span>
                </div>
                <div class="stat-values">
                    <div class="stat-item">
                        <div class="stat-value danger">5</div>
                        <div class="stat-label">Overdue</div>
                        <div class="stat-indicator danger">
                            <mat-icon>warning</mat-icon>
                            <span>Requires attention</span>
                        </div>
                    </div>
                    <div class="stat-divider"></div>
                    <div class="stat-item">
                        <div class="stat-value warning">23</div>
                        <div class="stat-label">Due Soon</div>
                        <div class="stat-indicator warning">
                            <mat-icon>schedule</mat-icon>
                            <span>Within 7 days</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vehicle Assignments -->
            <div class="stat-card assignments">
                <div class="card-header">
                    <div class="card-icon info">
                        <mat-icon>local_shipping</mat-icon>
                    </div>
                    <span class="card-title">Vehicle Assignments</span>
                </div>
                <div class="stat-values">
                    <div class="stat-item">
                        <div class="stat-value success">5</div>
                        <div class="stat-label">Assigned</div>
                        <div class="stat-indicator success">
                            <mat-icon>check_circle</mat-icon>
                            <span>Active</span>
                        </div>
                    </div>
                    <div class="stat-divider"></div>
                    <div class="stat-item">
                        <div class="stat-value warning">23</div>
                        <div class="stat-label">Unassigned</div>
                        <div class="stat-indicator">
                            <mat-icon>pending</mat-icon>
                            <span>Available</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vehicle Status -->
            <div class="stat-card status">
                <div class="card-header">
                    <div class="card-icon">
                        <mat-icon>directions_car</mat-icon>
                    </div>
                    <span class="card-title">Vehicle Status</span>
                </div>
                <div class="status-list">
                    <div class="status-item">
                        <div class="status-info">
                            <span class="status-dot active"></span>
                            <span class="status-name">Active</span>
                        </div>
                        <span class="status-count active">144,393</span>
                    </div>
                    <div class="status-item">
                        <div class="status-info">
                            <span class="status-dot inactive"></span>
                            <span class="status-name">Inactive</span>
                        </div>
                        <span class="status-count inactive">108</span>
                    </div>
                    <div class="status-item">
                        <div class="status-info">
                            <span class="status-dot shop"></span>
                            <span class="status-name">In Shop</span>
                        </div>
                        <span class="status-count shop">21</span>
                    </div>
                    <div class="status-item">
                        <div class="status-info">
                            <span class="status-dot out"></span>
                            <span class="status-name">Out of Service</span>
                        </div>
                        <span class="status-count out">5</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Charts Row -->
        <div class="charts-row">
            <!-- Fuel Cost Chart -->
            <div class="chart-card fuel-chart">
                <div class="card-header">
                    <div class="header-left">
                        <div class="card-icon chart">
                            <mat-icon>local_gas_station</mat-icon>
                        </div>
                        <span class="card-title">Fuel Cost</span>
                    </div>
                    <div class="chart-legend">
                        <span class="legend-item">
                            <span class="legend-dot"></span>
                            Monthly Cost
                        </span>
                    </div>
                </div>
                <div #chartContainer class="chart-container">
                    <ngx-charts-line-chart
                        class="line-chart-view"
                        [scheme]="colorScheme"
                        [schemeType]="schemeType"
                        [results]="fuelCost"
                        [animations]="animations"
                        [legend]="false"
                        [legendTitle]="legendFuelCostTitle"
                        [legendPosition]="legendPosition"
                        [gradient]="gradient"
                        [xAxis]="showXAxis"
                        [yAxis]="showYAxis"
                        [showXAxisLabel]="showXAxisLabel"
                        [showYAxisLabel]="showYAxisLabel"
                        [xAxisLabel]="xAxisLabelFuelCost"
                        [yAxisLabel]="yAxisLabelFuelCost"
                        [autoScale]="autoScale"
                        [timeline]="timeline"
                        [showGridLines]="showGridLines"
                        [curve]="curve"
                        [rangeFillOpacity]="rangeFillOpacity"
                        [roundDomains]="roundDomains"
                        [tooltipDisabled]="tooltipDisabled"
                        [showRefLines]="showRefLines"
                        [showRefLabels]="showRefLabels"
                        [referenceLines]="refLines"
                        [trimXAxisTicks]="trimXAxisTicks"
                        [trimYAxisTicks]="trimYAxisTicks"
                        [maxXAxisTickLength]="maxXAxisTickLength"
                        [maxYAxisTickLength]="maxYAxisTickLength"
                        (select)="select($event)"
                        (activate)="activate($event)"
                        (deactivate)="deactivate($event)">
                    </ngx-charts-line-chart>
                </div>
            </div>

            <!-- Shipment in Progress -->
            <div class="chart-card shipment-card">
                <div class="card-header">
                    <div class="header-left">
                        <div class="card-icon shipment">
                            <mat-icon>inventory_2</mat-icon>
                        </div>
                        <span class="card-title">Shipment in Progress</span>
                    </div>
                </div>
                <div class="shipment-grid">
                    <div class="shipment-column">
                        <div class="shipment-item booking">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">Booking</span>
                            </div>
                            <span class="shipment-count">18</span>
                        </div>
                        <div class="shipment-item pickup-site">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">At Pickup Site</span>
                            </div>
                            <span class="shipment-count">9</span>
                        </div>
                        <div class="shipment-item picked-up">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">Picked Up</span>
                            </div>
                            <span class="shipment-count">6</span>
                        </div>
                        <div class="shipment-item in-transit">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">In-transit</span>
                            </div>
                            <span class="shipment-count">27</span>
                        </div>
                    </div>
                    <div class="shipment-column">
                        <div class="shipment-item unloading">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">Un-loading</span>
                            </div>
                            <span class="shipment-count">36</span>
                        </div>
                        <div class="shipment-item delivered">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">Delivered</span>
                            </div>
                            <span class="shipment-count">17</span>
                        </div>
                        <div class="shipment-item billing">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">Billing</span>
                            </div>
                            <span class="shipment-count">12</span>
                        </div>
                        <div class="shipment-item closed">
                            <div class="shipment-info">
                                <span class="shipment-dot"></span>
                                <span class="shipment-name">Closed</span>
                            </div>
                            <span class="shipment-count">24</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Active Shipment Table -->
        <app-active-shipment [data]="data"></app-active-shipment>
    </div>
</div>
